#import "../fragments/user-email-fragment.graphql"

query GetSendableEmails {
    loggedInUser {
        id
        emailAddresses {
            ...UserEmail
        }
    }
}
